import { Navigate } from 'react-router'

const Index = () => {
  return <Navigate to={'/my-hub/diagnosis'} />
}

export default Index
